// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qo5o","col":"styles_col__2KN4y"};